/**
 * Design Tokens — Cabinet App
 *
 * Извлечены из homepage-eto-interesno v2.html (целевой сайт компании).
 * Используются как в Mantine theme, так и в style={{}} props напрямую.
 */

// ─── Цвета ───────────────────────────────────────────────────────────────
export const colors = {
  brand: {
    purple: '#7C3AED',
    purpleDark: '#5B21B6',
    purpleLight: '#A78BFA',
    orange: '#FF5E1A',
    orangeLight: '#FFB347',
    yellow: '#FFD600',
    green: '#16C172',
    blue: '#0EA5E9',
    pink: '#F43F8E',
  },
  text: {
    primary: '#1A0F3C',     // основной текст
    muted: '#6B6B8A',       // вторичный текст
    onDark: '#FFFFFF',
    onDarkMuted: 'rgba(255,255,255,0.7)',
  },
  bg: {
    page: '#F2F0F8',        // лавандово-серый фон страницы
    white: '#FFFFFF',
    softPurple: '#EDE9FE',
    softBlue: '#DBEAFE',
    softOrange: '#FFF7ED',
    softOrangeLight: '#FFF3E0',
    softGreen: '#F0FDF4',
    softGreenLight: '#DCFCE7',
    softYellow: '#FFF9E6',
    softPink: '#FCE7F3',
  },
  // Mantine-style 10-shades арей для primaryColor
  // Используется в createTheme.colors
  purpleShades: [
    '#F5F3FF', // 0
    '#EDE9FE', // 1
    '#DDD6FE', // 2
    '#C4B5FD', // 3
    '#A78BFA', // 4
    '#8B5CF6', // 5
    '#7C3AED', // 6 — основной
    '#6D28D9', // 7
    '#5B21B6', // 8
    '#4C1D95', // 9
  ],
  orangeShades: [
    '#FFF7ED',
    '#FFEDD5',
    '#FED7AA',
    '#FDBA74',
    '#FB923C',
    '#F97316',
    '#FF5E1A', // 6 — основной
    '#EA580C',
    '#C2410C',
    '#9A3412',
  ],
};

// ─── Градиенты ────────────────────────────────────────────────────────────
export const gradients = {
  hero: 'linear-gradient(135deg, #5B21B6 0%, #7C3AED 35%, #C026D3 70%, #F43F8E 100%)',
  darkCta: 'linear-gradient(135deg, #1e1040 0%, #2d1668 50%, #1a1235 100%)',
  softPurple: 'linear-gradient(135deg, #EDE9FE, #DBEAFE)',
  softOrange: 'linear-gradient(135deg, #FFF7ED, #FFF3E0)',
  softGreen: 'linear-gradient(135deg, #F0FDF4, #DCFCE7)',
};

// ─── Шрифты ───────────────────────────────────────────────────────────────
export const typography = {
  fontFamily: "'Nunito Sans', system-ui, -apple-system, sans-serif",
  fontFamilyHeading: "'Nunito', system-ui, -apple-system, sans-serif",
  fontWeight: {
    normal: 700,    // body text всё равно жирный (как в homepage)
    semibold: 800,
    bold: 900,
    black: 1000,
  },
  fontSize: {
    xs: '11px',
    sm: '13px',
    md: '14px',
    lg: '16px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '32px',
    '4xl': '48px',
  },
};

// ─── Радиусы ──────────────────────────────────────────────────────────────
export const radius = {
  sm: 8,
  md: 14,        // фон иконок
  lg: 20,        // карточки
  xl: 28,        // большие блоки
  pill: 100,     // pill-кнопки и чипы
};

// ─── Тени ─────────────────────────────────────────────────────────────────
export const shadows = {
  card: '0 4px 16px rgba(124,58,237,0.08)',
  cardHover: '0 16px 32px rgba(0,0,0,0.08)',
  cta: '0 6px 20px rgba(255,94,26,0.5)',
  ctaHover: '0 10px 28px rgba(255,94,26,0.55)',
  bubble: '0 8px 24px rgba(0,0,0,0.15)',
};

// ─── Spacing ──────────────────────────────────────────────────────────────
export const spacing = {
  xs: 8,
  sm: 12,
  md: 16,
  lg: 24,
  xl: 32,
  '2xl': 48,
  '3xl': 64,
};

const tokens = {
  colors,
  gradients,
  typography,
  radius,
  shadows,
  spacing,
};

export default tokens;
